"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DnDContext = void 0;
var _react = _interopRequireDefault(require("react"));
var DnDContext = exports.DnDContext = /*#__PURE__*/_react.default.createContext();